export default __webpack_public_path__ + "static/media/login-left-img.cf0f88bb.png";